;
define("header_mini_cart_summary.tpl", function(){});

